export default __webpack_public_path__ + "static/media/03-clouds-articles-1-3.89a725be.png";